<template>
  <div v-if="modalCheck" id="alert_modal" class="modal-wrap">
    <div class="modal-container">
      <div class="modal_header">
        <div class="header_close"></div>
        <div class="header_txt"></div>
        <div class="header_close">
          <!-- <a rel="modal:close" class="close_modal">
            <img src="../assets/images/icon/modal_close.png" alt="" />
          </a> -->
        </div>
      </div>
      <div class="modal_body">
        <div class="modal_contents" v-html="resultValue"></div>
      </div>
      <div class="modal_footer">
        <div v-if="cancelTrigger === '' || checkID !== ''" class="btn_area">
          <button
            v-if="checkJoin === 'success'"
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="movetoWelcome()"
          >
            확인
          </button>
          <button
            v-else-if="checkJoin === 'authTimeOut'"
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="movetoJoin()"
          >
            확인
          </button>
          <button
            v-else-if="checkJoin === 'systemErr'"
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="movetoInquiry()"
          >
            확인
          </button>
          <button
            v-else-if="checkJoin === 'dupMember'"
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="closeModal()"
          >
            확인
          </button>
          <button
            v-else
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="closeModal()"
          >
            확인
          </button>
        </div>
        <div v-else-if="checkCancel === 'cancel'" class="btn_area">
          <button
            class="confirm_modal_cancel btn_basic confirm_close"
            @click="closeModal()"
          >
            취소
          </button>
          <button
            id="download_confirm_modal_ok"
            class="confirm_modal_ok btn_basic"
            @click="movetoJoin()"
          >
            확인
          </button>
        </div>
        <div v-else class="btn_area">
          <button
            id="download_confirm_modal_ok"
            class="confirm_modal_ok btn_basic"
            @click="closeModal()"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    alertMsg: String,
    isOpen: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    endJoin: String,
    // eslint-disable-next-line vue/require-default-prop
    chkCancel: String,
    // eslint-disable-next-line vue/require-default-prop
    chkID: String,
  },
  emits: ['update:isOpen'],

  setup(props, { emit }) {
    const router = useRouter()

    const resultValue = ref('')
    const modalCheck = ref('')
    const checkJoin = ref('')
    const checkCancel = ref('')
    const checkID = ref('')

    watch(
      () => props.isOpen,
      () => {
        modalCheck.value = props.isOpen
        checkJoin.value = props.endJoin
        checkCancel.value = props.chkCancel
        checkID.value = props.chkID
        resultValue.value = props.alertMsg
      }
    )

    const closeModal = () => {
      emit('update:isOpen', false)
    }

    const movetoWelcome = () => {
      emit('update:isOpen', false)
      router.push({ path: '/welcomeMeta' })
    }
    const movetoJoin = () => {
      emit('update:isOpen', false)
      router.push({ path: '/join' })
    }
    const movetoInquiry = () => {
      emit('update:isOpen', false)
      router.push({ path: '/inquiry' })
    }

    return {
      resultValue,
      modalCheck,
      checkJoin,
      checkCancel,
      checkID,
      closeModal,
      movetoWelcome,
      movetoJoin,
      movetoInquiry,
    }
  },
}
</script>
<style>
/* dimmed */
.modal-wrap {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 5;
}

.modal-container {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 550px;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem !important;
  border-radius: 1.25rem !important;
  z-index: 5;
}

.modal-container .modal_header {
  margin-bottom: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 5;
}

.modal-container .modal_header .close_modal {
  display: block !important;
  width: 1rem !important;
  height: 1rem !important;
  z-index: 5;
}

.modal-container .modal_header .close_modal img {
  width: 100%;
  z-index: 5;
}

.modal-container .modal_body {
  margin-bottom: 1.25rem;
  z-index: 5;
}

.modal-container .modal_body .modal_contents {
  text-align: center;
  font-weight: 300;
  font-size: 1rem;
  line-height: 1.4375rem;
  color: #2d2d2d;
  z-index: 5;
}

.modal-container .modal_footer .btn_area {
  display: flex;
  gap: 0.5rem;
  z-index: 5;
}

.modal-container .modal_footer .btn_area button,
.modal-container .modal_footer .btn_area div {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  height: 3.25rem;
  font-size: 1rem;
  font-weight: bold;
  z-index: 5;
}

.modal-container .modal_footer .btn_area .confirm_close {
  color: #2d2d2d;
  background-color: #dfdfdf;
  border: 1px solid #dfdfdf;
  z-index: 5;
}
</style>
